<div class="filter-wrapper">
    <ham-filter
        [searchButtonLabel]="'aumico_core_table_filter_placeholder' | i18next"
        [placeholder]="'aumico_reports_notes_search_reports' | i18next"
        (filter)="filterProjects($event)"
    ></ham-filter>
</div>

<ham-table
    [dataSource]="filteredProjects"
    [pageSize]="5"
    (rowSelected)="onRowSelected($event)"
    [alreadySelectedRow]="selectedProjectForUploadAndMappingAutoFill"
>
    <!-- Header Definitions -->
    <ng-template hamHeaderCell hamTextCol> {{ 'aumico_annual_report_selection_list_company' | i18next }} </ng-template>
    <ng-template hamHeaderCell hamDateCol>
        {{ 'aumico_annual_report_selection_list_legal_form' | i18next }}</ng-template
    >
    <ng-template hamHeaderCell hamTextCol
        >{{ 'aumico_annual_report_selection_list_accounting_basis' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_annual_report_selection_list_current_year_date' | i18next }}
    </ng-template>

    <!-- Cell Definitions -->
    <ng-template hamCell let-element hamTextCol>
        <div class="company-name">
            <span>{{ element?.companyName || '-' }}</span>
            <span class="badge" *ngIf="element?.label">
                <ng-container>
                    <span>{{ element?.label }}</span>
                </ng-container>
            </span>
        </div>
    </ng-template>
    <ng-template hamCell let-element hamTextCol> {{ element?.legalForm?.name || '-' }} </ng-template>
    <ng-template hamCell let-element hamTextCol>
        {{ element?.accountingBasis?.text?.[currentLanguage] || '-' }}
    </ng-template>
    <ng-template hamCell let-element hamDateCol>
        {{ element?.balanceSheetDate ? (element.balanceSheetDate | dateLocale) : '-' }}
    </ng-template>
</ham-table>

<div class="actions-wrapper" *ngIf="showAutofillOptions">
    <div class="actions-title">{{ 'aumico_annual_report_select_autofill_options' | i18next }}</div>
    <div class="toggle-wrapper">
        <ham-toggle [disabled]="true" [formControlValue]="annualReportAutofillOptions.get('taxonamy')"></ham-toggle>
        <span> {{ 'aumico_annual_report_autofill_options_taxonamy' | i18next }} </span>
    </div>
    <div class="toggle-wrapper" *ngIf="'notes' | inReportSteps : activeArNavigation">
        <ham-toggle [formControlValue]="annualReportAutofillOptions.get('notes')"></ham-toggle>
        <span> {{ 'aumico_annual_report_autofill_options_notes' | i18next }} </span>
    </div>
    <div class="toggle-wrapper" *ngIf="'cashflow' | inReportSteps : activeArNavigation">
        <ham-toggle [formControlValue]="annualReportAutofillOptions.get('cashflow')"></ham-toggle>
        <span> {{ 'aumico_annual_report_autofill_options_cfs' | i18next }} </span>
    </div>
    <div class="toggle-wrapper" *ngIf="'aop' | inReportSteps : activeArNavigation">
        <ham-toggle [formControlValue]="annualReportAutofillOptions.get('aop')"></ham-toggle>
        <span>{{ 'aumico_annual_report_autofill_options_aop' | i18next }}</span>
    </div>
</div>
